import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_entitlement_auto_top_up_run_txn_line_RowClass,
} from '../../../dbschema';

export class EntitlementAutoTopUpRunTxnLineContainerModel extends BaseContainerModel {
  bl_aat_entitlement_auto_top_up_run_txn_line: bl_aat_entitlement_auto_top_up_run_txn_line_RowClass =
    new bl_aat_entitlement_auto_top_up_run_txn_line_RowClass();
}
